import React, { Component } from 'react';
import { Form, Tabs, Popover, Spin, Modal, message } from 'antd';
import ModifyDetailModal from './ModifyDetailModal';
import EditTemplateForm from './EditTemplateForm';
import ReferenceCourtyardModal from './ReferenceCourtyardModal';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';
import './style.less';

const { TabPane } = Tabs;

class WorkFlowTemplate extends Component {
    state = {
        panes: [],
        imgUrl: '',
        edit: false,
        activeKey: '0',
        loading: false,
        needRead: false,
        hospitalId: sessionStorage.hospitalId,
        hospitalName: sessionStorage.hospitalName,
        canReferenceStructure: false,
        referenceList: [],
    }

    componentDidMount() {
        const { investigationSiteName, relateId } = sessionStorage;
        const { hospitalName } = this.state;
        if (investigationSiteName && investigationSiteName !== '中心汇总' && hospitalName !== investigationSiteName) {
            const hash = location.hash.substr(1);
            if (hash == '/startUp/workFlow') {
                location.href = './#/startUp/siteStart';
            } else if (hash == '/shutOff/workFlow') {
                location.href = './#/shutOff/siteClose';
            }
        }
        this.queryTabList();
    }

    componentWillUnmount() {
        sessionStorage.removeItem('hospitalId');
        sessionStorage.removeItem('hospitalName');
        sessionStorage.removeItem('relateId');
    }

    queryTabList = () => {
        const { hospitalId } = this.state;
        const { activeKey } = this.props;
        let noticeActiveKey = null;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryAllReleasedList,
            data: {
                hospitalId,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    const panes = [];
                    const { relateId } = sessionStorage;
                    if (res.ssuModuleStructureList && res.ssuModuleStructureList.length > 0) {
                        res.ssuModuleStructureList.map((item, index) => {
                            panes.push({
                                title: item.ssuModuleStructureName,
                                content: null,
                                item: item.item,
                                key: item.ssuModuleStructureId + '',
                                canEditStructure: item.canEditStructure,
                            });
                            if(item.ssuModuleStructureId == relateId ) {
                                noticeActiveKey = item.ssuModuleStructureId + ''
                            }
                        });
                    }
                    this.setState({
                        panes,
                        loading: false,
                        canReferenceStructure: res.canReferenceStructure === true,
                        activeKey: noticeActiveKey || activeKey || res.ssuModuleStructureList[0].ssuModuleStructureId + '',
                    }, () => {
                        this.loadContentData();
                    });
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    loadContentData = () => {
        let { panes, activeKey, hospitalId } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.querySsuModuleStructureDetail,
            data: {
                hospitalId,
                type: 'HOSPITAL',
                ssuModuleStructureId: activeKey,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    const { needRead, remark, data, ssuStructureLogId, ssuHospitalStructureRead } = res;
                    const updateTime = res.updateTime ? res.updateTime.slice(0, 10) : '';
                    this.setState({
                        needRead,
                        updateTime,
                        loading: false,
                        remark,
                        templateData: data,
                        ssuStructureLogId,
                        ssuHospitalStructureRead,
                    }, () => {
                        panes.map(item => {
                            if (item.key == activeKey ) {
                                item.content = this.getContent(item);
                            } else {
                                item.content = null;
                            }
                        });
                        this.setState({ panes });
                    });
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            activeKey,
            edit: false,
        }, () => {
            this.loadContentData();
        });
    }

    changeEditState = (value) => {
        this.setState({ edit: value }, () => {
            this.loadContentData();
        });
    }

    /**
     * 引用：查询同主医院下已填写办事流程数据的其他院区
     */
    showReferenceModal = () => {
        const { hospitalId } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryReferenceCourtyardAreaList,
            data: {
                hospitalId,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    const datas = res.datas || [];
                    this.setState({ loading: false });
                    if (datas.length === 0) {
                        Modal.warning({
                            content: '无可引用院区',
                        });
                        return;
                    }
                    if (datas.length === 1) {
                        //只有一个可引用院区时无需选择，直接弹出引用确认
                        const onlyHospital = datas[0];
                        Modal.confirm({
                            title: '办事流程数据引用确认',
                            content: `将把院区“${onlyHospital.courtyardArea || onlyHospital.hospitalName}”的办事流程数据复制到当前医院：已有值的字段不会被覆盖；附件、表格、流程图仅在本医院对应内容为空时复制。确定引用吗？`,
                            onOk: () => this.handleReference(onlyHospital.hospitalId),
                        });
                        return;
                    }
                    this.setState({
                        referenceList: datas,
                    }, () => {
                        this.referenceModalRef.show();
                    });
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    /**
     * 引用确认后：把所选院区的办事流程数据复制到当前医院（已有值不覆盖），并重新加载
     */
    handleReference = referenceHospitalId => {
        const { hospitalId } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.referenceSsuData,
            data: {
                hospitalId,
                referenceHospitalId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success || '引用成功');
                this.queryTabList();
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    showDetailModal = () => {
        const { ssuStructureLogId = '' } = this.state;
        this.ModifyDetailModalRef.show({ ssuStructureLogId });
    }
    
    leave = () => {
        window.history.go(-1);
    }

    getFormValue = (data, params) => {
        const { edit } = this.state;
        data.forEach(item => {
            if (item.ssuModuleStructureDefineWebType == 'TEXT_AREA' || item.ssuModuleStructureDefineWebType == 'TEXT_TEXTAREA' || item.ssuModuleStructureDefineWebType == 'NUMBER_AREA') {
                params[item.ssuModuleStructureDefineId] = { value: item.value };
            } else if (item.ssuModuleStructureDefineWebType == 'TEXT_RADIO' || item.ssuModuleStructureDefineWebType == 'TEXT_SELECT') {
                if (edit) {
                    let value = item.value;
                    if (item.ssuModuleStructureDefineWebType == 'TEXT_RADIO') {
                        value = item.value ? Number(item.value) : (item.defaultValue ? Number(item.defaultValue) : undefined);
                    }
                    params[item.ssuModuleStructureDefineId] = { value };
                } else {
                    let value = '';
                    item.ssuModuleStructureDefineOptionList.forEach(i => {
                        if (i.ssuModuleStructureDefineOptionId == item.value) {
                            value = i.ssuModuleStructureDefineOptionName;
                        }
                    });
                    params[item.ssuModuleStructureDefineId] = { value };
                }
            } else if (item.ssuModuleStructureDefineWebType == 'TEXT_SEARCH_INPUT') {
                if (edit) {
                    params[item.ssuModuleStructureDefineId] = { value: item.value };
                } else {
                    params[item.ssuModuleStructureDefineId] = { value: item.valueShow };
                }
            } else if (item.ssuModuleStructureDefineWebType == 'TEXT_MULTI_AREA') {
                params[item.ssuModuleStructureDefineId] = { value: item.value ? item.value.split(',') : [] };
            } else if (item.ssuModuleStructureDefineWebType == 'TEXT_CHECKBOX') {
                if (edit) {
                    let value = null;
                    if (item.value) {
                        const array = item.value.split(',');
                        value = array.map(i => Number(i));
                    }
                    params[item.ssuModuleStructureDefineId] = { value };
                } else {
                    let value = '';
                    if (item.value) {
                        const array = item.value.split(',');
                        array.forEach(i => {
                            item.ssuModuleStructureDefineOptionList.forEach(j => {
                                if (j.ssuModuleStructureDefineOptionId == i) {
                                    value += `,${j.ssuModuleStructureDefineOptionName}`;
                                }
                            });
                        });
                    }
                    const newValue = value ? value.substring(1) : '';
                    params[item.ssuModuleStructureDefineId] = { value: newValue };
                }
            } else if (item.ssuModuleStructureDefineWebType == 'DATE_AREA') {
                if (edit) {
                    let value = null;
                    if (item.value) {
                        value = moment(item.value);
                    }
                    params[item.ssuModuleStructureDefineId] = { value };
                } else {
                    params[item.ssuModuleStructureDefineId] = { value: item.value };
                }
            } else if (item.ssuModuleStructureDefineWebType == 'FILE_UPLOAD' || item.ssuModuleStructureDefineWebType == 'FILE_OR_CHART') {
                let value = [];
                if (edit) {
                    if (item.ssuFileUploads && item.ssuFileUploads.length > 0) {
                        item.ssuFileUploads.forEach(i => {
                            value.push({
                                status: 'done',
                                name: i.fileName,
                                uid: i.ssuFileUploadId,
                                response: { ssuFileUploadId: i.ssuFileUploadId },
                            })
                        })
                    }
                } else {
                    if (item.ssuFileUploads && item.ssuFileUploads.length > 0) {
                        const { userId, curEmployeeCode } = sessionStorage;
                        item.ssuFileUploads.forEach(i => {
                            value.push({
                                name: i.fileName,
                                url: `${API_URL.hospital.downloadSsuFile}?ssuFileUploadId=${i.ssuFileUploadId}&curUserId=${userId}&curEmployeeCode=${curEmployeeCode ? encodeURIComponent(curEmployeeCode) : ''}`,
                            })
                        })
                    }
                }
                params[item.ssuModuleStructureDefineId] = { value };
            } else if (item.ssuModuleStructureDefineWebType == 'TABLE') {
                params[item.ssuModuleStructureDefineId] = { value: '' };
            } else if (item.ssuModuleStructureDefineWebType == 'SET_OF_FIELDS') {
                if (item.children && item.children.length > 0) {
                    this.getFormValue(item.children, params);
                }
            }
            params[`${item.ssuModuleStructureDefineId}_remark`] = { value: item.remark };
        });
    }

    updateImgUrl = (imgUrl) => {
        this.setState({ imgUrl });
    }

    getContent = (item) => {
        const { showEdit = false, showReference = false } = this.props;
        const { edit, imgUrl, remark = '', updateTime = '', confirmTime = '', confirmUser = '', activeKey, hospitalId, templateData, ssuHospitalStructureRead = null, needRead, canReferenceStructure } = this.state;
        const { canEditStructure = false } =item;
        //引用按钮只在第一个tab页显示
        const isFirstTab = this.state.panes.length > 0 && item.key === this.state.panes[0].key;
        const params = {};
        templateData.forEach(item => {
            if (item.children && item.children.length > 0) {
                this.getFormValue(item.children, params);
            }
        });
        const mapPropsToFields = () => ({
            ...params,
        });



        const EditTemplateForms = Form.create({ mapPropsToFields })(EditTemplateForm);
        return (
            <div>
                <div style={{ marginBottom: 10, overflow: 'hidden' }}>
                    <Popover
                        placement="right"
                        overlayClassName="propercent-pop"
                        content={<pre style={{ width: 240, whiteSpace: 'pre-line' }}>{remark}</pre>}
                    >
                        <div style={{ float: 'left', marginTop: 4 }}>
                            {/* <Icon type="info-circle" style={{ marginRight: 4, fontSize: '14px', color: '#5750c9', }} />
                            <a>填写说明</a> */}
                        </div>
                    </Popover>
                    {
                        <div style={{ float: 'right', display:'flex', width: ssuHospitalStructureRead ? 500 : 170, justifyContent: 'space-evenly' }}>
                            {
                                ssuHospitalStructureRead && <span>
                                    确认时间：{`${(ssuHospitalStructureRead || {}).updateTime.slice(0,10)}（${(ssuHospitalStructureRead || {}).userName}）`}
                                </span>
                            }
                            {/* {
                                ssuHospitalStructureRead &&
                                <span>确认人：{(ssuHospitalStructureRead || {}).userName}</span>
                            } */}
                            {
                                updateTime && <span>更新时间：{updateTime}</span>
                            }
                            {
                                updateTime &&
                                <i
                                    className="icon iconfont"
                                    onClick={this.showDetailModal}
                                    style={{ marginLeft: 4, fontSize: '16px', color: '#c4c1f1', cursor: 'pointer' }}
                                >&#xe601;</i>
                            }
                            
                        </div>
                    }
                    
                </div>
                <EditTemplateForms
                    edit={edit}
                    needRead={needRead}
                    imgUrl={imgUrl}
                    showEdit={showEdit}
                    showReference={showReference && isFirstTab}
                    canReferenceStructure={canReferenceStructure}
                    onReference={this.showReferenceModal}
                    hospitalId={hospitalId}
                    templateData={templateData}
                    updateImgUrl={this.updateImgUrl}
                    ssuModuleStructureId={activeKey}
                    canEditStructure={canEditStructure}
                    changeEditState={this.changeEditState}
                    ssuHospitalStructureRead={ssuHospitalStructureRead}
                    loadData={this.loadContentData}
                />
                <ModifyDetailModal ref={el => this.ModifyDetailModalRef = el} updateImgUrl={this.updateImgUrl} />
            </div>
        )
    }

    render() {
        const { panes, imgUrl, activeKey, hospitalName, loading } = this.state;
        return (
            <div className="work_flow">
                <div style={{ overflow: 'hidden' }}>
                    <div style={{ float: 'left', marginLeft: 10 }}>
                        <i
                            className="icon iconfont"
                            style={{ marginRight: 4, fontSize: '20px', color: '#1296DB'}}
                        >&#xe65b;</i>
                        {hospitalName}
                    </div>
                    <div style={{ float: 'right', marginRight: 10, color: '#1296DB', cursor: 'pointer' }} onClick={this.leave}>
                        <i
                            className="icon iconfont"
                            style={{ marginRight: 4, fontSize: '20px' }}
                        >&#xe63d;</i>
                        返回
                    </div>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Spin spinning={loading}>
                        <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                            {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content}</TabPane>)}
                        </Tabs>
                    </Spin>
                </div>
                <ReferenceCourtyardModal
                    ref={el => this.referenceModalRef = el}
                    List={this.state.referenceList}
                    onConfirm={this.handleReference}
                />
                {
                    imgUrl &&
                    <div className="flow_mask">
                        <div className="flow_content">
                            <div className="flow_close" onClick={() => this.updateImgUrl('')}>×</div>
                            <div className="flow_body">
                                <img className="large_img" src={imgUrl} />
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default WorkFlowTemplate;


// WEBPACK FOOTER //
// ./src/components/common/workFlowTemplate/index.js